import React from 'react'

export const GetDayDifference = (opentime, checkouttime) => {
    const getDateOnly = (date) => {
        let userdate = date.split(' ')[0].split('-')
        // console.log(userdate[1] + '/' + userdate[2] + '/' + userdate[0])
        return userdate[1] + '/' + userdate[2] + '/' + userdate[0]
    }
    if (opentime != null && checkouttime != null) {
        var startDate = new Date(getDateOnly(opentime.date));
        var endDate = new Date(getDateOnly(checkouttime.date));
        var seconds = Math.abs(endDate - startDate);
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        // console.log(diffDays);
        if (diffDays != 0) {
            return (
                <span className="overTimeDays">+{diffDays}<br /> DAY</span>
            )
        }
    } else {
        return (
            <span className="overTimeDays"></span>
        )
    }
}
